import { useEffect } from 'react'
import { useParams } from 'react-router'

import { useAppDispatch } from '@/store/hook'
import {
  getClassTypesAndProductCount,
  getProductSubCategoryOverviewData,
} from '@/store/slices/categorySlice'

import SubCategory from './index'

const SubCategoryPage = (props) => {
  const { categoryId, subCategoryId, classTypeId } = useParams()
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(getProductSubCategoryOverviewData({ categoryId }))
  }, [categoryId, dispatch])

  useEffect(() => {
    if (classTypeId) {
      dispatch(getClassTypesAndProductCount({ subCategoryId }))
    }
  }, [classTypeId, subCategoryId, dispatch])

  return (
    <SubCategory
      categoryId={categoryId}
      classTypeId={classTypeId}
      subCategoryId={subCategoryId}
      {...props}
    />
  )
}

export default SubCategoryPage
